import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import close from '../Asset/close.svg';
import { Modal, Form, Spinner } from 'react-bootstrap';
import Alert from './Alert';
import SelectSearch, { fuzzySearch } from "react-select-search";
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Preventive_Maintenance() {

    useEffect(() => {
        // getAccountList();
        getBranchList();
    }, [])
    let [sessOut, setSessOut] = useState(false);
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let userObj = getUserInfo();
    let [show, setShow] = useState(false);
    let [account, setAccount] = useState([]);
    let [equipment, setEquipment] = useState([]);//for store asselist
    let [site, setSite] = useState([]);
    let [saccont, setSaccout] = useState("");
    let [errorMsg, setErrorMsg] = useState({});
    let [pm, setPm] = useState({
        accountID: "",
        branchID: "",
        assetID: "",
        pm1: "",
        pm2: "",
        pm3: "",
        pm1Status: "",
        pm2Status: "",
        pm3Status: "",
        pm1ApiStatus: "",
        pm2ApiStatus: "",
        pm3ApiStatus: "",
        mId1: "",
        mId2: "",
        mId3: "",
        cr1: "",
        cr2: "",
        cr3: "",
        currentUtilization: "",
        isBlank: true,
        opType: ""
    });
    let [searchKey, setSearchKey] = useState("");
    let [keyError, setKeyError] = useState("");
    function resetPmData() {
        setPm({
            accountID: "",
            branchID: "",
            assetID: "",
            pm1: "",
            pm2: "",
            pm3: "",
            pm1Status: "",
            pm2Status: "",
            pm3Status: "",
            pm1ApiStatus: "",
            pm2ApiStatus: "",
            pm3ApiStatus: "",
            mId1: "",
            mId2: "",
            mId3: "",
            cr1: "",
            cr2: "",
            cr3: "",
            currentUtilization: "",
            isBlank: true,
            opType: ""
        });
        setSaccout("");
        setAccount([]);
        setEquipment([]);
    }
    function getAccount(e) {
        setSaccout(e)
        setSite([]);
        setEquipment([]);
        setPm({...pm,
            accountID: e,
            assetID: "",
            pm1: "",
            pm2: "",
            pm3: "",
            pm1Status: "",
            pm2Status: "",
            pm3Status: "",
            pm1ApiStatus: "",
            pm2ApiStatus: "",
            pm3ApiStatus: "",
            mId1: "",
            mId2: "",
            mId3: "",
            cr1: "",
            cr2: "",
            cr3: "",
            currentUtilization: "",
            isBlank: true,
            opType: ""
        })
        getEquipmentByAccount(e);
    }
    function getPmFormData(e) {
        //console.log("in getformdata")
        //setPm({ ...pm, [e.target.name]: e.target.value });
        if (e.target.name == "accountID") {
            setPm({
                ...pm,
                accountID: e.target.value,
                assetID: "",
                pm1: "",
                pm2: "",
                pm3: "",
                pm1Status: "",
                pm2Status: "",
                pm3Status: "",
                pm1ApiStatus: "",
                pm2ApiStatus: "",
                pm3ApiStatus: "",
                mId1: "",
                mId2: "",
                mId3: "",
                cr1: "",
                cr2: "",
                cr3: "",
                currentUtilization: "",
                isBlank: true,
                opType: "dropDown"
            });
            setSite([]);
            setEquipment([]);
            getEquipmentByAccount(e.target.value);
        }

        else if (e.target.name == "assetID") {
            setPm({
                ...pm,
                assetID: e.target.value,
                pm1: "",
                pm2: "",
                pm3: "",
                pm1Status: "",
                pm2Status: "",
                pm3Status: "",
                pm1ApiStatus: "",
                pm2ApiStatus: "",
                pm3ApiStatus: "",
                mId1: "",
                mId2: "",
                mId3: "",
                cr1: "",
                cr2: "",
                cr3: "",
                currentUtilization: "",
                isBlank: true,
                opType: "dropDown"
            });
            listPM(e.target.value);
        }

        else if (e.target.name == "branch") {
            setPm({
                accountID: "",
                branchID: e.target.value,
                assetID: "",
                pm1: "",
                pm2: "",
                pm3: "",
                pm1Status: "",
                pm2Status: "",
                pm3Status: "",
                pm1ApiStatus: "",
                pm2ApiStatus: "",
                pm3ApiStatus: "",
                mId1: "",
                mId2: "",
                mId3: "",
                cr1: "",
                cr2: "",
                cr3: "",
                currentUtilization: "",
                isBlank: true,
                opType: "dropDown"
            });
            setSearchKey("");
            setSaccout("");
            setAccount([]);
            setEquipment([]);
            if (e.target.value != "") {
                getAccountList(e.target.value);
            }

        }
        else if (e.target.name.includes("Status") && e.target.value == "Serviced") {
            setPm({ ...pm, [e.target.name]: e.target.value, ["cr" + (e.target.name).slice(2, 3)]: pm.currentUtilization });
        }
        else {
            setPm({ ...pm, [e.target.name]: e.target.value });
        }
    }
    let [branch, setBranch] = useState([]);
    function getBranchList() {
        fetch(environment.baseUrl + "getTechBranchesByRegion", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                //console.log("Accounts", resp)
                if (resp.code == 200) {
                    setBranch(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setBranch([]);
                }
            })
        })
    }

    function getAccountList(id) {
        fetch(environment.baseUrl + "getTechAccountsByBranch", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    branchID: id
                })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                //console.log("Accounts", resp)
                if (resp.code == 200) {
                    setAccount(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAccount([]);
                }
            })
        })
    }
    function getSiteByAccount(accid) {
        fetch(environment.baseUrl + "getSiteByAccID", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    "accountID": accid
                })
        }).then((result) => {
            result.json().then(res => {
                //console.log("getSiteByAccount:", res.data.result);
                // setEquipment(res.data.result);
                if (res.code == 200) {
                    setSite(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSite([]);
                }
            })
        })
    }
    function getEquipmentByAccount(did) {
        // let sid = parseInt(e);
        fetch(environment.baseUrl + "getTechEquipmentsByAccount?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    accountID: did,
                    branchID:pm.branchID
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setEquipment(res.data.result)
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setEquipment([]);
                }
            })
        })
    }
    function validateSearchKey() {
        resetPmData();
        if (searchKey == "") {
            setKeyError("Enter equipment serial no.");
        }
        else {
            equipmentBySearch()
        }
    }
    function equipmentBySearch() {
        fetch(environment.baseUrl + "techEquipmentSearch", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                assetID: searchKey
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    if (resp.data.result.length == 0) {
                        setKeyError("Equipment not found");
                    }
                    else if (resp.data.result[0][0]["preventive"].length) {
                        //console.log(resp.data.result[0][0]["preventive"])
                        setPm({
                            accountID: resp.data.result[0][0].accountID,
                            assetID: resp.data.result[0][0].assetID,
                            pm1: resp.data.result[0][0]["preventive"][0].pmReading,
                            pm2: resp.data.result[0][0]["preventive"][1].pmReading,
                            pm3: resp.data.result[0][0]["preventive"][2].pmReading,
                            pm1Status: resp.data.result[0][0]["preventive"][0].status,
                            pm2Status: resp.data.result[0][0]["preventive"][1].status,
                            pm3Status: resp.data.result[0][0]["preventive"][2].status,
                            pm1ApiStatus: resp.data.result[0][0]["preventive"][0].status,
                            pm2ApiStatus: resp.data.result[0][0]["preventive"][1].status,
                            pm3ApiStatus: resp.data.result[0][0]["preventive"][2].status,
                            mId1: resp.data.result[0][0]["preventive"][0].maintenanceID,
                            mId2: resp.data.result[0][0]["preventive"][1].maintenanceID,
                            mId3: resp.data.result[0][0]["preventive"][2].maintenanceID,
                            cr1: resp.data.result[0][0]["preventive"][0].servicedReading,//==null?"":resp.data.result[0][0]["preventive"][2].servicedReading,
                            cr2: resp.data.result[0][0]["preventive"][1].servicedReading,//==null?"":resp.data.result[0][0]["preventive"][1].servicedReading,
                            cr3: resp.data.result[0][0]["preventive"][2].servicedReading,//==null?"":resp.data.result[0][0]["preventive"][0].servicedReading,
                            currentUtilization: convertTo2decimal(resp.data.result[0][0].currentUtilization),
                            isBlank: false,
                            opType: "search"
                        });
                        setKeyError("");
                    }
                    else {
                        setPm({
                            accountID: "",
                            siteID: "",
                            assetID: "",
                            pm1: "",
                            pm2: "",
                            pm3: "",
                            pm1Status: "",
                            pm2Status: "",
                            pm3Status: "",
                            pm1ApiStatus: "",
                            pm2ApiStatus: "",
                            pm3ApiStatus: "",
                            mId1: "",
                            mId2: "",
                            mId3: "",
                            cr1: "",
                            cr2: "",
                            cr3: "",
                            currentUtilization: "",
                            isBlank: true,
                            opType: ""
                        });
                    }
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setPm({
                        accountID: "",
                        siteID: "",
                        assetID: "",
                        pm1: "",
                        pm2: "",
                        pm3: "",
                        pm1Status: "",
                        pm2Status: "",
                        pm3Status: "",
                        pm1ApiStatus: "",
                        pm2ApiStatus: "",
                        pm3ApiStatus: "",
                        mId1: "",
                        mId2: "",
                        mId3: "",
                        cr1: "",
                        cr2: "",
                        cr3: "",
                        currentUtilization: "",
                        isBlank: true,
                        opType: ""
                    });
                }
            })
        })
    }

    function listPM(assetID) {
        fetch(environment.baseUrl + "listPMAccount", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: pm.accountID,
                assetID: assetID,
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    if (resp.data.result[0][0]["preventive"].length) {
                        //console.log(resp.data.result[0][0]["preventive"])
                        setPm({
                            ...pm,
                            assetID: assetID,
                            pm1: resp.data.result[0][0]["preventive"][0].pmReading,
                            pm2: resp.data.result[0][0]["preventive"][1].pmReading,
                            pm3: resp.data.result[0][0]["preventive"][2].pmReading,
                            pm1Status: resp.data.result[0][0]["preventive"][0].status,
                            pm2Status: resp.data.result[0][0]["preventive"][1].status,
                            pm3Status: resp.data.result[0][0]["preventive"][2].status,
                            pm1ApiStatus: resp.data.result[0][0]["preventive"][0].status,
                            pm2ApiStatus: resp.data.result[0][0]["preventive"][1].status,
                            pm3ApiStatus: resp.data.result[0][0]["preventive"][2].status,
                            mId1: resp.data.result[0][0]["preventive"][0].maintenanceID,
                            mId2: resp.data.result[0][0]["preventive"][1].maintenanceID,
                            mId3: resp.data.result[0][0]["preventive"][2].maintenanceID,
                            cr1: resp.data.result[0][0]["preventive"][0].servicedReading,//==null?"":resp.data.result[0][0]["preventive"][2].servicedReading,
                            cr2: resp.data.result[0][0]["preventive"][1].servicedReading,//==null?"":resp.data.result[0][0]["preventive"][1].servicedReading,
                            cr3: resp.data.result[0][0]["preventive"][2].servicedReading,//==null?"":resp.data.result[0][0]["preventive"][0].servicedReading,
                            currentUtilization: convertTo2decimal(resp.data.result[0][0].currentUtilization),
                            isBlank: false
                        });
                    }
                    else {
                        setPm({
                            accountID: "",
                            siteID: "",
                            assetID: "",
                            pm1: "",
                            pm2: "",
                            pm3: "",
                            pm1Status: "",
                            pm2Status: "",
                            pm3Status: "",
                            pm1ApiStatus: "",
                            pm2ApiStatus: "",
                            pm3ApiStatus: "",
                            mId1: "",
                            mId2: "",
                            mId3: "",
                            cr1: "",
                            cr2: "",
                            cr3: "",
                            currentUtilization: "",
                            isBlank: true
                        });
                    }
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setPm({
                        accountID: "",
                        siteID: "",
                        assetID: "",
                        pm1: "",
                        pm2: "",
                        pm3: "",
                        pm1Status: "",
                        pm2Status: "",
                        pm3Status: "",
                        pm1ApiStatus: "",
                        pm2ApiStatus: "",
                        pm3ApiStatus: "",
                        mId1: "",
                        mId2: "",
                        mId3: "",
                        cr1: "",
                        cr2: "",
                        cr3: "",
                        currentUtilization: "",
                        isBlank: true
                    });
                }
            })
        })
    }
    function convertTo2decimal(val) {
        return val.toFixed(2);;
    }

    function validate() {
        //console.log("in validate")

        if (pm.opType == "search") {
            setShow(true);
        }
        else {
            let error = {};

            if (pm.accountID == "") {
                error.accountID = "This field is required"
            }
            if (pm.assetID == "") {
                error.assetID = "This field is required"
            }

            setErrorMsg(error);

            if (Object.keys(error).length == 0) {
                setShow(true);
                //console.log("sucessssss");
            }
            else {
                //console.log("errrro",error)
            }
        }
    }
    function updatePMData() {
        setShow(false);
        fetch(environment.baseUrl + "updatePreventiveMaintenance?", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                assetID: pm.assetID,
                accountID: pm.accountID,
                pmData: [
                    {
                        reading: pm.pm1,
                        maintenanceID: pm.mId1,
                        status: pm.pm1Status,
                        servicedReading: pm.pm1Status == "Serviced" ? pm.cr1 : "",
                        pmNumber: 1
                    },
                    {
                        reading: pm.pm2,
                        maintenanceID: pm.mId2,
                        status: pm.pm2Status,
                        servicedReading: pm.pm2Status == "Serviced" ? pm.cr2 : "",
                        pmNumber: 2
                    },
                    {
                        reading: pm.pm3,
                        maintenanceID: pm.mId3,
                        status: pm.pm3Status,
                        servicedReading: pm.pm3Status == "Serviced" ? pm.cr3 : "",
                        pmNumber: 3
                    },
                ]
            })
        }).then((result) => {
            result.json().then(res => {
                setAlert({
                    msg: res.msg,
                    status: true
                });
                if (res.code == 200) {
                    resetPmData();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }

    return (
        <div className='main-container'>
            <SessionFun show = {sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>Preventive Maintenance</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Preventive Maintenance</p>
            <div className="row card-box-block mt-3">
                <div className="col-md-12 full-col">
                    <div className="row">
                        <div className="col-sm-4">
                            <Form.Group className="mb-1" >
                                <Form.Label>Equipment serial No.</Form.Label>
                                <Form.Control type="text" name='assetID' className="textbox-back" placeholder="Search" value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                            </Form.Group>
                            <small className='red'>{keyError != "" ? keyError : ""}</small>
                        </div>
                        <div className="col-sm-3">
                            <Form.Group style={{ paddingTop: 30 }} >
                                <button className="btn btn-light lo-btn confirm-btn add-btn " onClick={validateSearchKey}>
                                    Search
                                </button>
                            </Form.Group>
                        </div>
                    </div>
                    <h5 className='line-text'><span>OR</span></h5>

                    <div className="row">
                        <div className="col-sm-3">
                            <Form.Group className="mb-3" >
                                <Form.Label>Area</Form.Label><span className='red'>*</span>
                                <Form.Control type="text" name='' value={userObj.areaName} className="textbox-back" readOnly />
                            </Form.Group>
                        </div>
                        <div className="col-sm-3">
                            <Form.Group className="mb-3" >
                                <Form.Label>Branch</Form.Label><span className='red'>*</span>
                                <Form.Select as="select" name='branch' className='textbox-back' value={pm.branchID} onChange={getPmFormData}>
                                    <option value="">Select Branch</option>
                                    {
                                        branch.map((item, index) =>
                                            <option value={item.branchID} key={index} >{item.branchName}</option>
                                        )
                                    }
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-sm-3">
                            <Form.Group className="mb-3" >
                                <Form.Label>Account</Form.Label><span className='red'>*</span>
                                <SelectSearch
                                    className="select-search"
                                    options={account.map(e => ({ name: e.accountName, value: e.accountID }))}
                                    onChange={getAccount}
                                    value={saccont}
                                    name="accountID"
                                    placeholder="Select Account"
                                    filterOptions={fuzzySearch}
                                    search
                                />
                            </Form.Group>
                        </div>
                        <div className="col-sm-3">
                            <Form.Group className="mb-3" >
                                <Form.Label>Equipment serial No.</Form.Label><span className='red'>*</span>
                                <Form.Select as="select" name='assetID' className='textbox-back' onChange={getPmFormData}>
                                    <option value="">Select Equipment</option>
                                    {
                                        equipment.map((item, index) =>
                                            <option value={item.assetID} key={index} >{item.assetID}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.assetID}</small>
                            </Form.Group>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row card-box-block mt-3">
                <div className="col-md-12 full-col">
                    <div className="row">
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>1st PM Reading Hrs</Form.Label>
                                <Form.Control type="text" name='' value={pm.pm1} readOnly className="textbox-back" placeholder="" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>{pm.pm1Status == "Serviced" ? "Serviced Reading Hrs" : "Current Reading Hrs"}</Form.Label>
                                <Form.Control type="text" name='' value={pm.pm1Status == "Serviced" ? pm.cr1 : pm.currentUtilization} readOnly className="textbox-back" placeholder="0" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Status</Form.Label>
                                <Form.Select as="select" name='pm1Status' value={pm.pm1ApiStatus != "Serviced" && pm.pm1 < pm.currentUtilization ? "Overdue" : pm.pm1Status} onChange={getPmFormData} className="textbox-back" disabled={pm.pm1ApiStatus == "Serviced" ? true : false}>
                                    <option value="">Select</option>
                                    <option value="Due">Due</option>
                                    <option value="Serviced">Serviced</option>
                                    <option value="Overdue">Overdue</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>2nd PM Reading Hrs</Form.Label>
                                <Form.Control type="text" name='' value={pm.pm2} readOnly className="textbox-back" placeholder="" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>{pm.pm2Status == "Serviced" ? "Serviced Reading Hrs" : "Current Reading Hrs"}</Form.Label>
                                <Form.Control type="text" name='' value={pm.pm2Status == "Serviced" ? pm.cr2 : pm.currentUtilization} readOnly className="textbox-back" placeholder="0" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Status</Form.Label>
                                <Form.Select as="select" name='pm2Status' value={pm.pm2ApiStatus != "Serviced" && pm.pm2 < pm.currentUtilization ? "Overdue" : pm.pm2Status} onChange={getPmFormData} className="textbox-back" disabled={pm.pm1ApiStatus == "Due" ? true : pm.pm2ApiStatus == "Serviced" ? true : false}>
                                    <option value="">Select</option>
                                    <option value="Due">Due</option>
                                    <option value="Serviced">Serviced</option>
                                    <option value="Overdue">Overdue</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>3rd PM Reading Hrs</Form.Label>
                                <Form.Control type="text" name='' value={pm.pm3} readOnly className="textbox-back" placeholder="" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>{pm.pm3Status == "Serviced" ? "Serviced Reading Hrs" : "Current Reading Hrs"}</Form.Label>
                                <Form.Control type="text" name='' value={pm.pm3Status == "Serviced" ? pm.cr3 : pm.currentUtilization} readOnly className="textbox-back" placeholder="0" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Status</Form.Label>
                                <Form.Select as="select" name='pm3Status' value={pm.pm3ApiStatus != "Serviced" && pm.pm3 < pm.currentUtilization ? "Overdue" : pm.pm3Status} onChange={getPmFormData} className="textbox-back" disabled={pm.pm2ApiStatus == "Due" ? true : pm.pm3ApiStatus == "Serviced" ? true : false}>
                                    <option value="">Select</option>
                                    <option value="Due">Due</option>
                                    <option value="Serviced">Serviced</option>
                                    <option value="Overdue">Overdue</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row justify-content-end" style={{ paddingRight: "15px" }}>
                        <button className="btn btn-light lo-btn confirm-btn float-left" onClick={validate} disabled={pm.isBlank}> Save </button>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={() => setShow(false)} centered backdrop="static" size="sm">
                <Modal.Header>
                    <Modal.Title>Confirm</Modal.Title>
                    <button onClick={() => setShow(false)} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className="row">
                        <p style={{ textAlign: "justify" }}>If you once select <strong>"Serviced"</strong> status then you cannot change the status back.</p>
                    </div>
                    <div className="row text-center mt-3">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-right" onClick={() => setShow(false)}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="btn btn-light lo-btn confirm-btn float-left" onClick={updatePMData}>
                                Confirm
                            </button>
                        </div>
                    </div>
                    {/* </Form> */}
                </Modal.Body>
            </Modal>



        </div>
    )
}

export default Preventive_Maintenance
